(function () {
    'use strict';

    angular.module("imApp").factory("transcarrierServiceActiveService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2657,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2658,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
